/* ============================================================
   ⛔ JUBILADO EL 21 SEP 2026 — NO HACE NADA.

   Lo sustituye `pn-tarjeta-compra.js`, que hace lo mismo pero:
     · tambien en movil (este arrancaba con `matchMedia('(hover: hover)')`
       y se disparaba en `mouseenter`, asi que en tactil no salia nunca),
     · con las tallas ENCIMA de la foto en vez de debajo,
     · y con los puntos de color al lado del precio.

   Se apago porque el 21 sep el pidio que las tarjetas de la PORTADA se
   vieran igual que las de coleccion. Con los dos ficheros vivos salian
   dos filas de tallas en la misma tarjeta.

   El codigo de abajo se deja tal cual por si hay que recuperar algo: el
   fichero no se puede borrar desde la API, hay que hacerlo desde Admin.
   Para volver a encenderlo hay que quitar el `return` de aqui Y apagar
   antes pn-tarjeta-compra.js, o se pisan.
   ============================================================ */
(function () {
  'use strict';
  return;

  /* ---- A partir de aqui, el fichero original del 14-16 ago 2026 ----

     TARJETA DE PRODUCTO: TALLAS Y ANADIR AL CARRITO — como gods-brand.com

     MEDIDO EN SU WEB (14 ago 2026, hover sobre tarjeta a 1280):
       "Anadir a la cesta"  12px · peso 400 · letter-spacing normal
                            caja de 70-74 x 32 -> DOS lineas
       tallas               12px · peso 400, a la derecha, en dos filas
       agotada              gris rgb(138,138,138) y tachada
       movil                NO existe: en tactil no hay raton

     ⚠️ EL TEXTO LARGO ERA INTENCIONADO. Decia solo "ANADIR" y se veia
     diminuto al lado de seis tallas, aunque los dos estaban a 12px. Lo
     que daba presencia al suyo es que "ANADIR A LA CESTA" parte en dos
     lineas. El ancho que fuerza el corte esta en pn-tarjeta-add.css
     (max-width: 78px).

     POR QUE HACIA FALTA JAVASCRIPT
     La seccion no pinta las variantes, asi que no hay forma de saber por
     CSS que tallas tiene cada prenda ni cuales estan agotadas. Se piden a
     /products/<handle>.js la primera vez que el raton entra en la
     tarjeta: asi no se cargaban 16 fichas al abrir la portada.

     DONDE ACTUABA (16 ago 2026)
       .destacados-nazalea__item  -> tarjetas de la portada. Su CSS de
                                     hover esta en pn-tarjeta-add.css.
       .product-grid__item        -> tarjetas del tema Horizon, SOLO en
                                     las paginas de coleccion. Su CSS
                                     esta en pn-coleccion.css.

     ⚠️⚠️ EL FILTRO POR /collections/ NO SE QUITABA. `.product-grid__item`
     lo usa tambien el buscador y otras plantillas, y ahi NO se carga
     pn-coleccion.css: las tallas saldrian sin estilo y visibles siempre.
     ---------------------------------------------------------------- */
})();